import { getDynamicSemanticToken } from '../../../DesignSystem';
import { getDefaultZoomUI } from '../../../ThemeProvider';
export function getDynamicThemeToken(theme) {
    // Get dynamic semantic design token,
    // which can automatically switch between light and dark content
    const semantic = getDynamicSemanticToken(theme);
    const { typography, shadow } = theme?.zoomUI ?? getDefaultZoomUI();
    return {
        padding: {
            default: '0 8px',
            small: '0 8px',
            medium: '0 8px',
            large: '0 12px',
            extraLarge: '0 12px',
        },
        fontSize: {
            default: typography.fontSize.body,
            small: typography.fontSize.subtitle,
            medium: typography.fontSize.body,
            large: '16px' /* typography.fontSize.bodyLarge */,
            extraLarge: '16px' /* typography.fontSize.bodyLarge */,
        },
        iconSize: {
            default: 16,
            small: 14,
            medium: 16,
            large: 18,
            extraLarge: 20,
        },
        iconRight: {
            default: 8,
            small: 8,
            medium: 8,
            large: 12,
            extraLarge: 12,
        },
        fontFamily: typography.fontFamily,
        height: {
            default: 32,
            small: 24,
            medium: 32,
            large: 40,
            extraLarge: 48,
        },
        borderRadius: {
            default: '8px',
            small: '6px',
            medium: '8px',
            large: '10px',
            extraLarge: '12px',
        },
        boxShadow: {
            pager: shadow.md,
        },
        color: {
            primary: {
                default: semantic.fill.primary,
            },
            secondary: {
                disabled: semantic.state.disable,
                placeholder: semantic.text.neutral,
            },
            text: semantic.text.stronger.neutral,
            menuText: semantic.text.stronger.neutral,
            emptyText: semantic.text.neutral,
        },
        background: {
            default: semantic.bg.default,
            secondary: {
                default: semantic.fill.default,
                hover: semantic.state.subtle.neutral.hover,
                active: semantic.state.subtle.neutral.press,
            },
        },
        border: {
            secondary: {
                default: semantic.component.input.border,
                disabled: semantic.state.subtle.disable,
                errorDisabled: semantic.state.subtle.error.disable,
                paper: semantic.border.subtle.neutral,
            },
            danger: {
                default: semantic.border.error,
            },
        },
        outline: {
            default: 'none',
            focus: `2px solid ${semantic.border.primary}`,
        },
        outlineOffset: 2,
    };
}
